export const content = {
  title: "Book Now",
  image: {
    url: "./assets/bookNowHero.jpg",
    alt: "Da62 flying into the sunset",
  }
}